export default "__VITE_ASSET__1c559e64__"